import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import InventoryEdit from '@src/components/inventory/InventoryEdit';

interface Props {
  open: boolean;
  close(): void;
}

function InventoryDialog({ open, close }: Props) {
  return (
    <Dialog
      open={open}
      aria-labelledby="Reassign Scan"
      fullScreen
      sx={{ margin: '20px' }}>
      <DialogTitle
        id="alert-dialog-title"
        sx={(theme) => ({
          display: 'flex',
          alignItems: 'center',
          gap: theme.spacing(2),
        })}></DialogTitle>
      <DialogContent>
        <InventoryEdit />
      </DialogContent>
      <DialogActions>
        <Button onClick={close} variant="contained" color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default InventoryDialog;
